import { createStyles, makeStyles } from '@material-ui/styles';
export var useStyles = makeStyles(function (theme) {
    var _a, _b;
    return createStyles({
        root: {
            outline: 0,
        },
        message: {
            outline: 0,
        },
        action: (_a = {},
            _a[theme.breakpoints.up('sm')] = {
                marginTop: 0,
            },
            _a.marginTop = 10,
            _a.marginLeft = 12,
            _a.color = theme.palette.text.primary,
            _a.backgroundColor = 'transparent',
            _a),
        dismissAction: (_b = {},
            _b[theme.breakpoints.up('sm')] = {
                marginTop: 0,
                marginRight: 0,
            },
            _b.marginLeft = 0,
            // Since the dismiss icon is centered within the icon, but the design has it aligned with the beginning of the text,
            // we move the icon up in small breakpoint.
            _b.marginTop = -8,
            _b.marginRight = -8,
            _b),
    });
});
//# sourceMappingURL=Banner.styles.js.map